import { render } from "./EmailPreviewPane.vue?vue&type=template&id=25855fd8&scoped=true&ts=true"
import script from "./EmailPreviewPane.vue?vue&type=script&lang=ts"
export * from "./EmailPreviewPane.vue?vue&type=script&lang=ts"

import "./EmailPreviewPane.vue?vue&type=style&index=0&id=25855fd8&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25855fd8"]])

export default __exports__